<template>
  <div class="login-container">
    <div class="logo-area">
      <img src="@/assets/logo.png" alt="Logo" class="logo" />
      <h1 class="logo-title">凯尚设计</h1>
    </div>
    <form @submit.prevent="login">
      <div class="form-group">
        <label for="phone">手机号</label>
        <input
          type="tel"
          id="phone"
          v-model.trim="phone"
          required
          maxlength="30"
          placeholder="请输入手机号"
        />
      </div>
      <div class="form-group">
        <label for="password">密码</label>
        <input
          type="password"
          id="password"
          v-model.trim="password"
          required
          minlength="1"
          placeholder="请输入密码"
        />
      </div>
      <!-- <button type="submit" :disabled="loading" class="login-btn">
        {{ loading ? '登录中...' : '立即登录' }}
      </button> -->
      <button type="submit"  class="login-btn">
        立即登录
      </button>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter  } from "vue-router";
import { getCurrentInstance } from 'vue';
import { ElMessage } from 'element-plus';

export default {
  setup() {
    const phone = ref('');
    const password = ref('');
    const router = useRouter(); // 获取路由实例
    const { proxy } = getCurrentInstance();

    const login = async () => {
      const url = '/login/login';
      proxy.$tools.request(url, 
      {
        reqBody:{mobileNo:phone.value,password:password.value},
      })
        .then(response => {
          // 处理响应数据
          if('00000000' === response.data.rspHead.returnCode){
            //跳转到首页
            const rsptoken = response.data.rspBody.token;
            localStorage.setItem('token', rsptoken); // 存储token

            router.push('/');
             // 返回上级页面，可以使用router的go方法
            // router.go(-1);
          }else{
            ElMessage.error(response.data.rspHead.returnMsg); // 弹框提示错误信息
          }
        })
        .catch(error => {
          // 处理错误情况
          ElMessage.error('系统异常，请联系管理员'+error); 
        });
    };




    return {
      phone,
      password,
      login
    };
  },
};
</script>

<style scoped>
.login-container {
  max-width: 440px;
  margin: 50px auto;
  padding: 40px 30px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

.logo-area {
  text-align: center;
  margin-bottom: 40px;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
}

.logo-title {
  font-size: 24px;
  color: #303133;
  font-weight: 500;
  letter-spacing: 2px;
  margin: 0;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.form-group {
  margin-bottom: 24px;
  width: 100%; /* 新增宽度限制 */
  box-sizing: border-box; /* 新增盒模型设置 */
}

label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

input {
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  transition: border-color 0.3s ease;
  box-sizing: border-box; /* 确保padding不影响总宽度 */
}

input:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 4px rgba(64, 158, 255, 0.2);
}

input::placeholder {
  color: #c0c4cc;
}

.login-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, #409eff, #337ecc);
  color: white;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.login-btn:hover {
  background: linear-gradient(135deg, #337ecc, #409eff);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.login-btn:disabled {
  background: #c0c4cc;
  cursor: not-allowed;
  box-shadow: none;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-container {
    margin: 20px;
    padding: 30px;
  }
  
  .logo-title {
    font-size: 20px;
  }
}
</style>
